import type { JSX } from 'react';
import type { SoftHyphenInjectorProps } from './types';
import { classes } from '../../utils/classes';

/**
 * `SoftHyphenInjector` is a React component that takes a text prop.
 * It replaces instances of "{--}" in the text with a soft hyphen HTML entity "&shy;".
 * The updated text is then rendered inside a span element component as HTML.
 *
 * @component
 * @param {SoftHyphenInjectorProps} props - The properties that define the `SoftHyphenInjector` component.
 * @param {string} props.text - The text to be processed and displayed.
 * @param {string} props.className - Additional classNames for Styling
 *
 * @example
 * <SoftHyphenInjector text="This is a test text with a soft hyphen{--}in the middle of the word." />
 *
 * @returns {JSX.Element} The `SoftHyphenInjector` component.
 */
export const SoftHyphenInjector = ({ text, className }: SoftHyphenInjectorProps): JSX.Element => {
  const replacedText = text.replace(/{--}/g, '&shy;');

  return (
    <span
      className={classes('soft-hyphen-injector', className)}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: replacedText }}
    />
  );
};
